module.exports = __webpack_public_path__ + "static/works-punchey-site-3ab4af861b1d8b1d24542bfd17de0280.png";